import { bustCache } from '../components/RushMid/render/battleAssetVersion';
import { soundUrl } from './audioEngine';
import { getAsset } from './assetStore';
import { runWhenIdle } from './browserSurface';

let started = false;

export function prefetchLoadingAssets(): void {
  if (started || typeof window === 'undefined') return;
  started = true;
  void getAsset(bustCache('/battle/rush_mid_loading.webp')).catch(() => undefined);
  const run = () => {
    void getAsset(soundUrl('menu_theme')).catch(() => undefined);
  };
  runWhenIdle(run, { timeoutMs: 5000, fallbackDelayMs: 2000 });
}
